/**
 * Home intro cards: overflow “View all” + mobile swipe pager dots.
 */
(function () {
  const CLIP_SELECTOR = '.uucck-home-intro__card-body--clip';

  function updateCard(card) {
    const body = card.querySelector(CLIP_SELECTOR);
    const footer = card.querySelector('[data-view-all-overflow]');
    if (!body || !footer) return;

    if (footer.dataset.alwaysShow === 'true') {
      footer.hidden = false;
      return;
    }
    const overflows = body.scrollHeight > body.clientHeight + 2;
    footer.hidden = !overflows;
  }

  function runOverflow() {
    document.querySelectorAll('.uucck-home-intro__card').forEach(updateCard);
  }

  function initSwipePager() {
    const track = document.querySelector('[data-uucck-intro-track]');
    const pager = document.querySelector('[data-uucck-intro-pager]');
    if (!track || !pager) return;

    const dots = [...pager.querySelectorAll('[data-uucck-intro-dot]')];
    const cards = [...track.querySelectorAll('.uucck-home-intro__card')];
    if (dots.length !== cards.length) return;

    function setActive(index) {
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function indexFromScroll() {
      const left = track.scrollLeft;
      let best = 0;
      let bestDist = Infinity;
      cards.forEach((card, i) => {
        const dist = Math.abs(card.offsetLeft - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    let scrollTimer;
    track.addEventListener(
      'scroll',
      () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => setActive(indexFromScroll()), 80);
      },
      { passive: true }
    );

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const i = Number(dot.dataset.uucckIntroDot);
        const card = cards[i];
        if (!card) return;
        track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
        setActive(i);
      });
    });

    setActive(0);
  }

  function init() {
    runOverflow();
    initSwipePager();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', runOverflow);
})();
